import { useDataGridTasks } from 'components/data-grid/hooks';
import { GridModel } from './models';
export const useGridDocumentTasks = () => {
  return useDataGridTasks<GridModel>();
};
